<template>
	<div v-if="manualList != null" class="main-panel">
        <table height=100% width=100% cellpadding=0 cellspacing=0>
            <tr class="itemheader">
                <td width="30%" style="vertical-align:top">
                    <div class="inner-panel">
                        <div class="panel-group-title" v-t="'message.manual_category'">
                        </div>
                        <table width=100%>
                            <div v-for="manual in manualList">
                                <button class="transparent" @click="handleCategoryChange(manual.category)">
                                    <tr v-if="isSelected(manual.category)" class="manual-record-selected" width="100%">
                                        <td class="manual-category">{{ manual.categoryName }} </td>
                                    </tr>
                                    <tr v-else class="manual-record" width="100%">
                                        <td class="manual-category">{{ manual.categoryName }} </td>
                                    </tr>
                                </button>
                            </div>
                        </table>
                    </div>
                </td>
                <td width="70%" style="vertical-align:top">
                    <div class="inner-panel">
                        <div v-if="selectedCategoryName == 'externalService'">
                            <ManualExtService :showGoogleStt="appData.basicContract.planType === 0"></ManualExtService>
                        </div>
                        <div v-else-if="selectedCategoryName == 'samlAuthentication'">
                            <ManualSamlAuth></ManualSamlAuth>
                        </div>
                        <div v-else>
                            <div class="object-titlebox">
                                <div class="object-titlebox-left" v-t="'message.menu_manual'"></div>
                                <div class="object-titlebox-right" style="padding-right:20px" v-t="'message.item_version'"></div>
                            </div>
                            <table width="100%">
                                <tr v-for="manual in selectedManualList" class="manual-record" style="display:table-row">
                                    <td class="manual-name" style="width:80%;display: table-cell"><a :href="getDounloadUrl(manual.fileName)" :download="manual.name" target="_blank">{{ manual.name }}</a></td>
                                    <td class="manual-name" style="width:20%;display: table-cell;padding-right:20px;text-align: right">{{ manual.version }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </td>
            </tr>
        </table>
	</div>
</template>

<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import commonUtil from './commonutil.js';
import ManualExtService from './ManualExtService.vue';
import ManualSamlAuth from './ManualSamlAuth.vue';

export default {
    props: {
        appData: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            manualList: null,
            selectedCategoryName: null,
            selectedManualList: null,
        }
    },
    methods: {
        handleCategoryChange(categoryName) {
            this.selectedCategoryName = categoryName
            var manuals = this.manualList.filter(function(item, index) {
                if (item.category == categoryName) return true;
            });
            this.selectedManualList = manuals[0].manual;
        },
        getDounloadUrl(fileName) {
            return "https://www.science-arts.com/downloads/buddycom/manual/" + fileName;
        },
        checkQueryParam() {
            if (typeof this.$route.query == "undefined") {
                self.selectedCategoryName = "user";
                return;
            }
            if ((this.$route.query.item == "externalService") ||
                (this.$route.query.item == "samlAuthentication")) {
                this.selectedCategoryName = this.$route.query.item;
                let query = Object.assign({}, this.$route.query)
                delete query["item"]
                this.$router.push({query: query})
            } else {
                self.selectedCategoryName = "user";
            }
        },
        setManualCategory() {
            this.manualList = [];
            if (this.$i18n.locale == 'ja') {
                let self = this;
                window['$manualList'] = function(data){
                    self.manualList = data;
                    self.manualList.push({ category: "externalService", categoryName: commonUtil.getMessageText(self.$i18n,"manual_category_externalService"), manual:[]});
                    self.manualList.push({ category: "samlAuthentication", categoryName: "SAML認証", manual:[]});
                    self.selectedManualList = self.manualList[0].manual;
                    self.checkQueryParam()
                };
                var script = document.createElement('script');
                script.src = "https://www.science-arts.com/downloads/buddycom/manual/manuallist.js" + "?ts=" + new Date().getTime();;
                document.body.appendChild(script);
            } else {
                this.manualList.push({ category: "externalService", categoryName: commonUtil.getMessageText(this.$i18n,"manual_category_externalService"), manual:[]});
                this.manualList.push({ category: "samlAuthentication", categoryName: "SAML Authentication", manual:[]});
            }
        },
        isSelected(categoryName) {
            if (this.selectedCategoryName == categoryName) {
                return true;
            } else {
                return false;
            }
        }
    },
    created: function() {
        this.setManualCategory();
    },
    components: {
        ManualExtService,
        ManualSamlAuth
    },
    watch: {
        '$i18n.locale'(newVal) {
            this.setManualCategory();
        },
        '$route' (to, from) {
            this.checkQueryParam()
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.inner-panel {
    overflow-x: hidden;
    overflow-y: auto;
}
a, a:hover, a:visited, a:link, a:active {
    color: #333B48;
    text-decoration: none;
}
td a {
    display: block;
}

.panel-group-title {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 12px;
    width: 100%;
    vertical-align: middle;
    background-color: #f6f6f6;
    color: #848991;
}

button.transparent {
    border-style: none;
    background-color: transparent;
    cursor: pointer;
    padding: 0;
    outline: 0;
    width: 100%;
}

.manual-category {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 14px;
}
.manual-record {
    color: #848991;
    border-bottom:1px #eee solid;
    display: block;
}
.manual-record-selected {
    background-color: #ecf1fa;
    color: #848991;
    border-bottom:1px #eee solid;
    display: block;
}
.manual-record:hover {
    background-color: #ecf1fa;
}

.manual-name {
  padding: 10px;
  padding-left: 20px;
  color: #848991;
  font-size: 14px;
  vertical-align: middle;
}

.manual-size {
  padding: 10px;
  position: relative;
  text-align : right;
  vertical-align: middle;
  font-size: 14px;
}
.default-message {
    position: relative;
    top: 10%;
    color: #848991;
    text-align: center;
    vertical-align: middle;
}
</style>
